import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import { translate } from 'react-i18next';

import { Section, HorizontalCard } from '../../src/components/Layout';
import { Container } from '../../src/components/Grid';
import Wysiwyg from '../../src/components/Wysiwyg';

const ContentWrapper = styled.div`
  margin-top: 10px;
`;

class Info extends React.PureComponent {
  render() {
    const { t, data, hours, imgMobile, img } = this.props;

    return (
      <Section>
        <Container>
          <Fade up>
            <HorizontalCard
              img={img}
              imgMobile={imgMobile}
              title={t('common:home.infos.schedule.title')}
              icon="schedule"
              imgPosition="right"
              contentPosition={'start'}
              badge
              badgeHours={hours}
            >
              <ContentWrapper>
                <Wysiwyg content={data.opening + data.closing_time} />
              </ContentWrapper>
            </HorizontalCard>
          </Fade>
        </Container>
      </Section>
    );
  }
}

Info.propTypes = {
  data: PropTypes.object.isRequired,
  hours: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  imgMobile: PropTypes.string,
  img: PropTypes.string
};

export default translate()(Info);
